import CommonRouter from './CommonRouter'
import { searchRoutes } from '../routes/SearchRoutes'
const CurrentNavigator = CommonRouter('Search', searchRoutes.ObjectSearch)
export default CurrentNavigator
